import React, { useEffect, useState } from 'react';
import ShareKakao from './ShareKakao';

type TextType = {
  text1: string;
  text2: string;
};

const ShareKakaoBtn: React.FC<TextType> = ({ text1, text2 }) => {
  const [shareButton, setShareButton] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://developers.kakao.com/sdk/js/kakao.js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      setShareButton(true);
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div>
      {shareButton === true ? <ShareKakao text1={text1} text2={text2} /> : null}
    </div>
  );
};

export default ShareKakaoBtn;
